// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tarifasProveedorFullfilledReducer = makeSetReducer(['tarifas_envio_proveedor/fullfilled']);
